import { Gravity, EnergyUnit, EnergyTypes } from './Settings'
import { MathFormula } from './Math';
import QuantityConversion from './QuantityConversion';
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit
} from './FuelMath';
import FuelCalcBase from './FuelCalcBase';

const roundValue = 1;

// Holds formula for energy conversion.
export default class EngeryConvesionService extends FuelCalcBase {

    constructor() {
        super();
    }

    GravityCheck({ Valid, ErrorDescription }) {
        return {
            Valid: Valid,
            ErrorDescription: ErrorDescription
        };
    }

    static initialValue = {
        energy_MJ_kg: "",
        energy_Btu_lb: "",
        energy_Btu_bbl: "",
        energy_Btu_gal: "",
        energy_kCal_kg: ""
    };
    static errors = [];
    static response = { ... this.initialValue };

    static ConvertEnergy = (config) => {

        let result = {};
        this.response = { ... this.initialValue };
        // {
        //     energyUnit, 
        //     energyValue, 
        //     gravityType, 
        //     gravityValue
        // }
        ;
        switch (config.energyUnit) {
            case EnergyUnit.MJ_KG:
            default:
                result = this.Convert_MJ_kg(config);
                return result;
            case EnergyUnit.BTU_LB:
                result = this.Convert_Btu_lb(config);
                return result;
            case EnergyUnit.BTU_BBL:
                {
                    let value = config.energyValue / 42.0;
                    result = this.Convert_Btu_gal({ ...config, energyValue: value });
                    return result
                }
            case EnergyUnit.BTU_GAL:
                result = this.Convert_Btu_gal(config);
                return result;
            case EnergyUnit.BTU_KCAL:
                result = this.Convert_kCal_kg(config);
                return result;
        }
    }

    static CheckGravity = (unit, value, energyValue) => {
        
        const check = new EngeryConvesionService().GravityCheck({ Valid: false, ErrorDescription: "" });

        switch (unit) {
            case VpsGravityType.Density:
                {
                    if (energyValue === "") {
                        check.ErrorDescription = new FuelCalcBase().GetFuelCalcErrorDescription(1151);
                    } else {
                        check.Valid = true;
                    }
                    //if (VerifyNumericLimit_Btw_MinMax(value, Gravity.DENSITY_MIN, Gravity.DENSITY_MAX))
                    //check.Valid = true;
                    //else
                    //check.ErrorDescription = new FuelCalcBase().GetFuelCalcErrorDescription(1020);

                }
                break;
            case VpsGravityType.SG:
                {
                    if (energyValue === "") {
                        check.ErrorDescription = new FuelCalcBase().GetFuelCalcErrorDescription(1151);
                    } else {
                        check.Valid = true;
                    }
                    //if (VerifyNumericLimit_Btw_MinMax(value, Gravity.SG_MIN, Gravity.SG_MAX)) {
                    //check.Valid = true;
                    //}else {
                    //check.ErrorDescription = new FuelCalcBase().GetFuelCalcErrorDescription(1023);
                    // }
                }
                break;
            case VpsGravityType.API:
                {
                    if (energyValue === "") {
                        check.ErrorDescription = new FuelCalcBase().GetFuelCalcErrorDescription(1151);
                    } else {
                        check.Valid = true;
                    }
                    //if (VerifyNumericLimit_Btw_MinMax(value, Gravity.API_MIN, Gravity.API_MAX))
                    // check.Valid = true;
                    // else
                    //check.ErrorDescription = new FuelCalcBase().GetFuelCalcErrorDescription(1022);
                }
                break;
        }
        return check;
    }

    // TODO: Need to check
    static GetMT_1000gal = (gravityType, gravity, energyValue) => {
        
        const conversion = new QuantityConversion();
        let error = false;
        let errorMsg = "";

        try {
            const check = this.CheckGravity(gravityType, gravity, energyValue);
            if (check.Valid) {

                conversion.Commodity = VpsCommodity.RefinedProduct;
                conversion.ObservedGravityValue = gravity;
                conversion.ObservedGravityType = gravityType;
                if (gravityType == VpsGravityType.Density) {
                    conversion.ObservedGravityTemperature = "15";
                    conversion.ObservedGravityTemperatureUnit = VpsTemperatureUnit.Celcius;
                }
                else {
                    conversion.ObservedGravityTemperature = "60";
                    conversion.ObservedGravityTemperatureUnit = VpsTemperatureUnit.Fahrenheit;
                }

                conversion.ObservedQuantityValue = "1000";
                conversion.ObservedQuantityUnit = VpsQuantityUnit.USGallons;
                conversion.ObservedQuantityTemperature = "60";
                conversion.ObservedQuantityTemperatureUnit = VpsTemperatureUnit.Fahrenheit;
                conversion.AlternateQuantityUnit = VpsQuantityUnit.MetricTons;
                conversion.ConvertQuantity();
                if (!conversion.Exception) {
                    return MathFormula.roundAccurately(parseFloat(conversion.MetricTons), 4);
                }
                else {
                    new FuelCalcBase().RaiseError_PropNme("Get MT/1000gal", conversion.ExceptionDescription);
                    error = true;
                    errorMsg = conversion.ExceptionDescription;
                }
            }

            else {
                new FuelCalcBase().RaiseError_PropNme("Get MT/1000gal", check.ErrorDescription);
                error = true;
                errorMsg = check.ErrorDescription;
            }

            if (error) {
                // alert(errorMsg);
                this.errors.push(errorMsg);
                // EngeryConvesionService.response = {... this.initialValue};
                EngeryConvesionService.response = null;
                return;
            }
        }
        catch (ex) {
            new FuelCalcBase().RaiseError_PropNme("Get MT/1000gal", ex.Message);

        }

    }

    static compute_Gal_Bbl = (gravityType, gravityValue, energyValue) => {
        
        // ToDo: Need to Uncomment 
        if (gravityType && gravityValue || energyValue === "") {
            // let mT_1000gal = this.GetMT_1000gal(gravityType, gravityValue);
            // if (mT_1000gal) {
            //     let energy_Btu_gal = (this.energy_Btu_lb * mT_1000gal) / 0.454;
            //     let energy_Btu_bbl = this.energy_Btu_gal * 42.0;
            //     return { energy_Btu_gal, energy_Btu_bbl };
            // }

            let mT_1000gal = this.GetMT_1000gal(gravityType, gravityValue, energyValue);
            if (mT_1000gal) {
                let energy_Btu_gal = (EngeryConvesionService.response.energy_Btu_lb * mT_1000gal) / 0.454;
                let energy_Btu_bbl = energy_Btu_gal * 42.0;
                return { energy_Btu_gal, energy_Btu_bbl };
            }
        }
        return null;
    }

    // ToDo: Need to Uncomment
    static Convert_MJ_kg = ({ energyValue: value, gravityType, gravityValue }) => {
        
        EngeryConvesionService.response.energy_MJ_kg = value;
        EngeryConvesionService.response.energy_kCal_kg = MathFormula.roundAccurately((238.846 * value), roundValue);

        // EngeryConvesionService.response.energy_Btu_lb = RoundValueASTM_ValAsStr((value / 0.002326).toString(), 1);
        EngeryConvesionService.response.energy_Btu_lb = MathFormula.roundAccurately(RoundValueASTM_ValAsStr((value / 0.002326).toString(), 1), roundValue);

        let energy = this.compute_Gal_Bbl(gravityType, gravityValue, value);
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.DENSITY_MIN, Gravity.DENSITY_MAX) && gravityType === 1) {
            if (energy != null) {
                let roundValue1 =0;
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue1);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue1);

            }
        }
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.API_MIN, Gravity.API_MAX) && gravityType === 3) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);

            }
        }
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.SG_MIN, Gravity.SG_MAX) && gravityType === 2) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);

            }
        }


        // ToDo: Need to remove.
        // EngeryConvesionService.response.energy_Btu_gal = 10;
        // EngeryConvesionService.response.energy_Btu_bbl = 20;

        return EngeryConvesionService.response;
    }

    static Convert_Btu_lb = ({ energyValue: value, gravityType, gravityValue }) => {
        
        EngeryConvesionService.response.energy_Btu_lb = value;
        EngeryConvesionService.response.energy_MJ_kg = MathFormula.roundAccurately((value * 0.002326), roundValue);
        EngeryConvesionService.response.energy_kCal_kg = MathFormula.roundAccurately((238.846 * value * 0.002326), roundValue);
        let energy = this.compute_Gal_Bbl(gravityType, gravityValue, value);
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.DENSITY_MIN, Gravity.DENSITY_MAX) && gravityType === 1) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);
            }
        }
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.API_MIN, Gravity.API_MAX) && gravityType === 3) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);

            }
        }
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.SG_MIN, Gravity.SG_MAX) && gravityType === 2) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);

            }
        }

        // ToDo: Need to remove.
        // EngeryConvesionService.energy_Btu_gal = 10;
        // EngeryConvesionService.energy_Btu_bbl = 20;

        return EngeryConvesionService.response;

    }

    // Todo: Need to uncomment.
    static Convert_kCal_kg = ({ energyValue: value, gravityType, gravityValue }) => {
        EngeryConvesionService.response.energy_kCal_kg = value;

        //EngeryConvesionService.Energy_Btu_lb = RoundValueASTM_ValAsStr((value / (238.846 * 0.002326)).toString(), 1);
        EngeryConvesionService.response.energy_Btu_lb = MathFormula.roundAccurately(RoundValueASTM_ValAsStr((value / (238.846 * 0.002326)).toString(), roundValue), 2);

        EngeryConvesionService.response.energy_MJ_kg = MathFormula.roundAccurately(((value) / 238.846), roundValue);
        let energy = this.compute_Gal_Bbl(gravityType, gravityValue, value);
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.DENSITY_MIN, Gravity.DENSITY_MAX) && gravityType === 1) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);
            }
        }
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.API_MIN, Gravity.API_MAX) && gravityType === 3) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);

            }
        }
        if (VerifyNumericLimit_Btw_MinMax(gravityValue, Gravity.SG_MIN, Gravity.SG_MAX) && gravityType === 2) {
            if (energy != null) {
                EngeryConvesionService.response.energy_Btu_gal = MathFormula.roundAccurately(energy.energy_Btu_gal, roundValue);
                EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately(energy.energy_Btu_bbl, roundValue);

            }
        }
        // ToDo: Need to remove.
        // EngeryConvesionService.energy_Btu_gal = 10;
        // EngeryConvesionService.energy_Btu_bbl = 20;

        return EngeryConvesionService.response;

    }

    // Need to uncomment.
    static Convert_Btu_gal = ({ energyValue: value, gravityType, gravityValue }) => {
        EngeryConvesionService.response.energy_Btu_gal = value;
        EngeryConvesionService.response.energy_Btu_bbl = MathFormula.roundAccurately((value * 42.0), roundValue);
        if (gravityType && gravityValue) {

            // mT_1000gal = this.GetMT_1000gal();
            // if (mT_1000gal) {
            //     let energy_Btu_lb = RoundValueASTM_ValAsStr(((value * 0.454) / MT_1000gal).toString(), 1);
            //     EngeryConvesionService.energy_Btu_lb = energy_Btu_lb;
            //     EngeryConvesionService.energy_MJ_kg = energy_Btu_lb * 0.002326;
            //     EngeryConvesionService.energy_kCal_kg = ((238.846 * energy_Btu_lb) * 0.002326)
            // }
            let mT_1000gal = this.GetMT_1000gal();
            if (mT_1000gal) {
                let energy_Btu_lb = RoundValueASTM_ValAsStr(((value * 0.454) / mT_1000gal).toString(), 1);
                EngeryConvesionService.response.energy_Btu_lb = MathFormula.roundAccurately(energy_Btu_lb, roundValue);
                EngeryConvesionService.response.energy_MJ_kg = MathFormula.roundAccurately((energy_Btu_lb * 0.002326), roundValue);
                EngeryConvesionService.response.energy_kCal_kg = MathFormula.roundAccurately(((238.846 * energy_Btu_lb) * 0.002326), roundValue);
            }

            // ToDo: Need to remove.
            // EngeryConvesionService.energy_Btu_lb = 10;
            // EngeryConvesionService.energy_MJ_kg = 20;
            // EngeryConvesionService.energy_kCal_kg = 30;
        }
        return EngeryConvesionService.response;
    }
}

